/* Love Cashmere reviews: preserved copy with section-safe automatic rotation with a gentle fade. */
(() => {
  'use strict';
  if (window.LoveCashmereReviews) return;
  const repairReviews = [
      {
        text: "I sent two jumpers here and they came back looking like new! I highly recommend this service – much more sustainable than buying new jumpers every season!",
        name: "K. Walther"
      },
      {
        text: "Absolutely incredible workmanship. The repair is invisible and my cashmere feels brand new again.",
        name: "S. McArthur"
      },
      {
        text: "Fantastic service from start to finish. Communication was excellent and the results exceeded expectations.",
        name: "L. Bennett"
      },
      {
        text: "I was nervous sending my favourite jumper away, but it came back flawless. I wouldn’t hesitate to use this service again.",
        name: "R. Collins"
      },
      {
        text: "Sustainable, professional and beautifully finished. This service saved a very sentimental piece for me.",
        name: "E. Thompson"
      },
      {
        text: "I have just put on my cashmere cardigan which you repaired for me and I am delighted! It feels brand new and the repair is amazing, practically invisible.",
        name: "C. Tilli"
      },
      {
        text: "Thank you so much for the repairs to my knitwear. You've done a great job and I'm delighted!",
        name: "S. Benzie"
      },
      {
        text: "A HUGE thank you. The jumper has been rescued. Don’t know how you did it, but someone has worked a minor miracle.",
        name: "S. Rasmussen"
      },
      {
        text: "I am so delighted with my restored cashmere tunic and cardigan. I never imagined they could again look as new. The whole process was easy to follow and the outcome was my dearly loved cashmere garments looking wonderful again.",
        name: "J. Marsh"
      },
      {
        text: "Thank you so much for the most beautiful repair work on my cashmere cardigan. I have loved wearing it for many years now and couldn’t believe how it came back looking fresh and new again. The packaging was special too.",
        name: "C. Howarth"
      },
      {
        text: "I have just received my rejuvenated pullover and I wanted to say how thrilled I am. It looks new — one can barely see the repairs. Thank you very much.",
        name: "R. King"
      },
      {
        text: "So impressed with your service and the great job you and your team have done on my jumper!",
        name: "D. Reffell"
      },
      {
        text: "It was at home when I got there after work looking perfect, thanks! I’m so pleased.",
        name: "G. Salaman"
      },
      {
        text: "I just received my two cashmeres. You have done a very beautiful job. Thank you so much. I will use the cedar piece for my cashers!",
        name: "Y. Fogarty"
      },
      {
        text: "I have received my sweater back and I am absolutely delighted with the results. I honestly could not tell you where the holes were — the sweater looks brand new!",
        name: "L. Lockert"
      },
      {
        text: "I just had to write and thank you for the wonderful work you have carried out on my cashmere throws. They have come back to me like new! I will be proud to once again display them.",
        name: "C. Tilli"
      },
      {
        text: "I have never seen such an excellent repair apart from one you did on a Loro Piana jersey. My wife and I strained our eyes trying to find the repairs. Well done. A brilliant service.",
        name: "J. Downes"
      },
      {
        text: "I just wished to let you know that I received my green cashmere jumper today, beautifully wrapped, repaired and rejuvenated! Thank you so much for your excellent service - it really has breathed new life into a well-worn favourite.",
        name: "M. Knight"
      },
      {
        text: "Just wanted to say I received the jumpers and they look amazing!! Thank you very much!",
        name: "N. Desmond"
      },
      {
        text: "I just had to email your company. I received my 3 cashmere items back today and it was just like opening a package with 3 brand new items of clothing in it!! I am so thrilled to be able to wear my much loved striped sweater again.",
        name: "J. Foster"
      },
      {
        text: "I received the items today (better than new) and I am more than happy with your service. Thanks a lot!",
        name: "O. Zimmer"
      },
      {
        text: "I had been on the verge of throwing out a favourite cashmere sweater with many memories attached so was very pleased and impressed that this jumper has just arrived back looking like new and with no sign of the damage caused by moths due to my neglect.",
        name: "A. King"
      },
      {
        text: "Just want to say what a wonderful service you provide. You are lovely to deal with and the end result is superb.",
        name: "K. Fforde"
      },
      {
        text: "Very happy with my jumper thank you.",
        name: "V. Watson"
      }
    ];
  // Legacy empty-data fallback (A. Lyons, "Beautiful quality and craftsmanship.")
  // is deliberately not shown: no source attribution was available to verify it.
  const instances = new Map();
  const selections = new Map();
  const selector = '.review-rotator, .product-review-rotator';
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const intervalMs = 8000;
  const fadeMs = 320;

  function destroy(element) {
    const state = instances.get(element);
    if (!state) return;
    clearTimeout(state.timer);
    clearTimeout(state.fadeTimer);
    state.element.classList.remove('fade-out');
    state.visibility?.disconnect();
    state.region.removeEventListener('mouseenter', state.pause);
    state.region.removeEventListener('mouseleave', state.resume);
    state.region.removeEventListener('focusin', state.pause);
    state.region.removeEventListener('focusout', state.onFocusOut);
    instances.delete(element);
  }

  function measure(state) {
    if (!state.element.isConnected) return destroy(state.element);
    const clone = state.element.cloneNode(true);
    clone.dataset.lcReviewMeasuring = '';
    clone.setAttribute('aria-hidden', 'true');
    clone.inert = true;
    clone.style.cssText = `position:absolute;visibility:hidden;pointer-events:none;left:-9999px;width:${state.element.getBoundingClientRect().width}px;min-height:0;`;
    // Keep the same ancestors so scoped fonts/spacing match the visible quote.
    state.element.after(clone);
    const text = clone.querySelector('.review-text');
    const name = clone.querySelector('.review-person');
    let height = 0;
    state.reviews.forEach((review) => {
      text.textContent = review.text;
      name.textContent = review.name;
      height = Math.max(height, clone.getBoundingClientRect().height);
    });
    clone.remove();
    if (height) state.element.style.minHeight = `${Math.ceil(height)}px`;
  }

  function initReader(element) {
    if (instances.has(element) || element.hasAttribute('data-lc-review-measuring')) return;
    const text = element.querySelector('.review-text');
    const name = element.querySelector('.review-person');
    if (!text || !name) return;
    let reviews;
    if (element.classList.contains('product-review-rotator')) {
      try { reviews = JSON.parse(element.dataset.reviews || '[]'); } catch { reviews = []; }
      if (!Array.isArray(reviews)) reviews = [];
      reviews = reviews.filter((review) => typeof review?.text === 'string' && typeof review?.name === 'string' && review.text.trim() && review.name.trim());
    } else reviews = repairReviews.slice();
    if (!reviews.length) {
      element.hidden = true;
      return;
    }
    element.hidden = false;
    const key = element.dataset.reviewKey;
    const previous = key && selections.get(key);
    const previousIndex = reviews.findIndex((review) => review.text === previous?.text && review.name === previous?.name);
    const content = element.querySelector('[data-review-content]');
    const region = element.closest('.lc-review-reader') || element;
    const state = { element, region, reviews, index: Math.max(0, previousIndex), timer: null, fadeTimer: null, visible: !('IntersectionObserver' in window) };
    const show = () => {
      // Automatic changes must not repeatedly announce while someone browses the page.
      content?.setAttribute('aria-live', 'off');
      text.textContent = reviews[state.index].text;
      name.textContent = reviews[state.index].name;
      if (key) selections.set(key, reviews[state.index]);
    };
    const canRotate = () => element.isConnected && instances.has(element) && reviews.length > 1 && state.visible && !document.hidden && !reducedMotion.matches && !region.matches(':hover') && !region.contains(document.activeElement);
    state.pause = () => {
      clearTimeout(state.timer);
      clearTimeout(state.fadeTimer);
      state.timer = null;
      state.fadeTimer = null;
      element.classList.remove('fade-out');
    };
    state.resume = () => {
      state.pause();
      if (!canRotate()) return;
      state.timer = setTimeout(() => {
        if (!canRotate()) return;
        element.classList.add('fade-out');
        state.fadeTimer = setTimeout(() => {
          if (!canRotate()) return state.pause();
          state.index = (state.index + 1) % reviews.length;
          show();
          element.classList.remove('fade-out');
          state.resume();
        }, fadeMs);
      }, intervalMs);
    };
    state.onFocusOut = () => queueMicrotask(state.resume);
    instances.set(element, state);
    region.addEventListener('mouseenter', state.pause);
    region.addEventListener('mouseleave', state.resume);
    region.addEventListener('focusin', state.pause);
    region.addEventListener('focusout', state.onFocusOut);
    if ('IntersectionObserver' in window) {
      state.visibility = new IntersectionObserver((entries) => {
        state.visible = entries.some((entry) => entry.isIntersecting);
        state.resume();
      }, { threshold: 0.25 });
      state.visibility.observe(element);
    }
    show();
    state.resume();
    requestAnimationFrame(() => measure(state));
  }

  function init(scope = document) {
    if (scope.matches?.(selector)) initReader(scope);
    scope.querySelectorAll?.(selector).forEach(initReader);
  }
  document.addEventListener('visibilitychange', () => instances.forEach((state) => state.resume()));
  reducedMotion.addEventListener('change', () => instances.forEach((state) => state.resume()));
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => instances.forEach(measure), 150);
  }, { passive: true });
  window.LoveCashmereReviews = { init };
  function boot() {
    init();
    new MutationObserver((records) => {
      for (const record of records) {
        record.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE && !node.hasAttribute('data-lc-review-measuring')) init(node);
        });
      }
      if (records.some((record) => record.removedNodes.length)) {
        instances.forEach((state, element) => { if (!element.isConnected) destroy(element); });
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    instances.forEach((state, element) => { if (event.target.contains(element)) destroy(element); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
